import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'whatwg-fetch';
class getInfoClient extends Component {
  constructor(){
    super();
    this.state = {
        nombre_cliente : "",
        anio:"",
        telefono:""
    }
  }
  get_List_Cliente =()=>{
    const url= this.props.dir_url + "webapp/getDataClient";
    const token =  this.props.token
    const token_Client =  this.props.token_Client
    var obj = { accion:'datacliente', token, token_Client};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          nombre_cliente:data[0].msg[0].nombre,
          anio:data[0].msg[0].anio,
          telefono:data[0].msg[0].codigo,
          id_forma_pago:data[0].msg[0].id_forma_pago
        })
      }
    })
    .catch(console.log)
  }
  salir =(opcion)=>{
    if(opcion==='si'){
      this.props.setCerrarSesion()
    }
  }
  cerrarSesion = () => {
    confirmAlert({
      title: 'Cerrar Sesión',
      message: '¿Desea cerrar sesión?',
      buttons: [
        {
          label: 'Sí',
          onClick: () => this.salir('si')
        },
        {
          label: 'No',
          onClick: () => this.salir('no')
        }
      ]
    })
  }

  render() {
    return (
      <div className="cssversion_menu cssversion_colorblanco">
        <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}  onClick={ () => this.props.get_go_to('')}>
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') }  />
          </div>
          <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
            <span className="span-global-link" >Mi información</span>
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_pxh50 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}}  >
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') }  />
          </div>
          <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
            <span className="span-global" >
              {(this.state.nombre_cliente)?
                <React.Fragment>{this.state.nombre_cliente}</React.Fragment>
                :
                <img alt="Cargando Imagen . . ." style={{"height":"50px"}} src={ require('../image/loading.gif')}/>
              }
            </span>
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_pxh50 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}}  >
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15443912291582004495-128.png') }  />
          </div>
          <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
            <span className="span-global" >
            {(this.state.telefono)?
              <React.Fragment>{this.state.telefono}</React.Fragment>
              :
              <img alt="Cargando Imagen . . ." style={{"height":"50px"}} src={ require('../image/loading.gif')}/>
            }
            </span>
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_pxh50 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}}  >
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') }  />
          </div>
          <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
            <span className="span-global" >
            {(this.state.anio)?
              <React.Fragment>Año de Nacimiento: {this.state.anio}</React.Fragment>
              :
              <img alt="Cargando Imagen . . ." style={{"height":"50px"}} src={ require('../image/loading.gif')}/>
            }
            </span>
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_pxh50 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}}   onClick={ () => this.props.get_go_to_sub("editdatosclientes")}>
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4798580041582004495-128.png') }  />
          </div>
          <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
            <span className="span-global" >Datos de Facturación</span>
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_pxh50 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} onClick={ () => this.cerrarSesion()}>
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/20635100751582004491-128.png') }  />
          </div>
          <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
            <span className="span-global" >Cerrar Sesión</span>
          </div>
        </div>
      </div>
    )
  }

  componentDidMount (){
    this.get_List_Cliente()
  }
}
export default getInfoClient
/*<div className="cssversion_pw100 cssversion_pxh50 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}}  onClick={ () => this.props.get_go_to_sub("editformapago")}>
  <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
    <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  />
  </div>
  <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
    <span className="span-global" >Forma de Pago</span>
  </div>
</div>*/
